import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TenantService } from "../Services/tenant.service";
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
    selector: "list-add",
    templateUrl: "./list.add.html",
    styles: [`
mat-list{    
    max-height: 200px;
    overflow-y: auto;
    min-width: 400px;
}
mat-list.embed{
    max-height:90%;
    }
loading-items{

}
div.error{
    color:red;
    font-weight:bold;
}
span.text {
    width: 100%;
    display: inline-block;
    text-align: left;
}
`],
    imports: [MatProgressSpinner, MatFormField, MatInput, FormsModule]
})
export class AddListComponent {
    private alias: string;
    private _newListString: string = "";
    lists: any;
    errorString: string;
    constructor(
        private readonly tenantService: TenantService
    ) {
        this.getLists();
        this.newListString = new EventEmitter<string>();
    }

    @Input()
    embedded: boolean;

    @Output()
    newListString: EventEmitter<string>;

    getLists() {
        this.tenantService.getLists()
            .subscribe(res => {
                this.lists = res;
            });
    }

    validate() {
        if (this.lists.find(l => l.FriendlyName!=null && l.FriendlyName.toLowerCase() === this._newListString.toLowerCase().trim())) {
            this.errorString = "Error - List with this name already exists";
            return;
        }
        if (this._newListString.length < 1) {
            this.errorString = "Error - No new text supplied";
            return;
        }
        this.errorString = "";
        this.newListString.emit(this._newListString);
    }
}